import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { IListingSearchResponse, IPoiSearchResponse, ISearchAutocompleteRequest } from '@curbnturf/entities';
import { objectToUrlParams } from '@curbnturf/helpers';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'search';

export type SearchIndex = 'poi' | 'listing';

/** Elasticsearch tooling. Replaces @curbnturf/search-components' SearchService (CachedHttpClient). */
@Injectable({ providedIn: 'root' })
export class AdminSearchApiService {
  private readonly http = inject(HttpClient);

  autocomplete(index: SearchIndex, query: ISearchAutocompleteRequest): Observable<IPoiSearchResponse | IListingSearchResponse> {
    return this.http.get<IPoiSearchResponse | IListingSearchResponse>(`${API_URL}/${index}-autocomplete?${objectToUrlParams(query)}`);
  }

  stats(index: SearchIndex): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${API_URL}/${index}/stats`);
  }

  /** Drops and rebuilds the indexes from PostgreSQL (server AdminAuthGuard). Slow; search is degraded meanwhile. */
  recreateIndexes(): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(`${API_URL}/indexes/recreate`);
  }
}
